import React, { useState, useEffect } from 'react';
import styles from './style.scss';
import SliderWrapper from 'jd-library/SliderWrapper';
import ReviewModal from '../../ui/molecules/ReviewModal/ReviewModal';
import { useHistory, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { clickTrack, getListingData, setPreviousTabIndex, setTabStatus } from '../../../actions/products';
import { toggleFeedbackForm } from './redux/action';
import RatingScale from '../../ui/molecules/RatingScale';
import ReviewReasons from '../../ui/molecules/ReviewReasons';
import Axios from 'axios';
import CommentFeedback from '../../ui/molecules/CommentFeedback';
import FeedbackHeader from '../../ui/molecules/FeedbackHeader';

const FeedbackSlider = props => {
    const [showRedirectingModal,toggleModal] = useState(true);
    const [apiData,setApiData] = useState(null);
    const [score,updateScore] = useState(0);
    const [reason,updateReason] = useState([]);
    const [grade,updateGrade] = useState('default');
    const [feedBackText, setFeedBackText] = useState("")
    const history = useHistory();
    const token = useSelector(state => state.session.token);
    const feedBackOption = useSelector(state => state.feedback.options);
    const dispatch = useDispatch();

    useEffect(() => {
        Axios.get('/marketplace/static/php/web/b2bWebsite.php?action=getCSATDetails&token='+token).then(res => {
            if(res.data.status) {
                setApiData(res.data)
                setTimeout(() => {
                    history.goBack()
                }, 3000);
            }
        }).catch(err => {
            console.log(err)
        })
    },[])

    const getGrade = score => {
        let newGrade = '';
        if(score <= apiData.ratingOptions.poor.max)
            newGrade = 'poor';
        else if(score <= apiData.ratingOptions.statisfactory.max)
            newGrade = 'statisfactory';
        else
            newGrade = 'good';
        updateGrade(newGrade);
        updateScore(score);
        updateReason([])
    }

    const handleUpdateReason = (data) => {
        const tmpAry = [...reason]
        if (tmpAry.includes(data)) {
            const ind = tmpAry.findIndex(item => item == data)
            tmpAry.splice(ind, 1)
        } else {
            tmpAry.push(data)
        }
        updateReason([...tmpAry])
    }

    const onSubmit = () => {
        dispatch(clickTrack({li: 'rating_scale',ll: 'dc_csat'}));
        if(reason?.length) {
            dispatch(clickTrack({li: 'predef_reason',ll: 'dc_csat'}));
        }
        let url = '/marketplace/static/php/web/b2bWebsite.php?action=updateCSATRating&token='+token+'&rating='+score+'&reason='+reason.join("|")+'&feedback='+feedBackText
        Axios.get(url).then(res => {
            let tabKey = feedBackOption?.isObjectionable ? 'objectionable' : undefined;
            history.goBack();
            dispatch(getListingData({ tabKey }))
            dispatch(setTabStatus({ tabKey }))
            dispatch(setPreviousTabIndex({ tabIndex: 0 }));
        })
    }

    const hideModel = () => {
        setTimeout(() => {
            toggleModal(false)
        }, 10);
    }

    return showRedirectingModal ? 
        <ReviewModal onHidden={hideModel} /> :
        <SliderWrapper
            header={{
                leftIcons: [],
                rightIcons: [{
                    className: 'icon-HDRcross',
                    onClick: () => {
                        history.goBack()
                        dispatch(getListingData({ tabKey: undefined }))
                        dispatch(setTabStatus({ tabKey: undefined }))
                        dispatch(setPreviousTabIndex({ tabIndex: 0 }));
                        dispatch(clickTrack({li: 'cross_icon',ll: 'dc_csat'}))
                    } 
                }]
            }}
            footer={{
                btnProps: [{
                    children: 'Submit',
                    disabled: grade == 'default' ? true : false,
                    className: grade == 'default' ? styles['disable-btn'] : '',
                    onClick: () => {
                        onSubmit();
                    }
                }]
            }}
            onHidden={() => dispatch(toggleFeedbackForm({show:false}))}
        >
            <div className={styles['feedback-data']}>
                <FeedbackHeader 
                    title={apiData?.title || ''} 
                    subTitle={apiData?.subTitle || ''} 
                    imgSrc={apiData?.ratingOptions[grade].image || ''} 
                />
                <RatingScale onChange={score => getGrade(score)} subTitle={apiData?.subTitle1 || ''} />
                {apiData?.ratingOptions[grade]?.options?.length ? 
                <>
                    <ReviewReasons 
                        reasons={apiData.ratingOptions[grade].options} 
                        selectedReasons={reason} 
                        onChange={data => handleUpdateReason(data)} 
                        subTitle={apiData?.subTitle2}
                    />
                    <CommentFeedback
                        labelVal={"Comment / Feedback"}
                        textAreaVal={feedBackText}
                        textAreaPlaceHolder={"Please provide any other feedback for us to improve upon"}
                        textAreaChange={setFeedBackText}
                    />
                </>
                : null}
            </div>
        </SliderWrapper>
        
};

export default withRouter(FeedbackSlider);